<template>
  <tr v-if="!isResponsive" :class="isHighlighted && 'highlight'">
    <td>
      <input
        type="checkbox"
        class="base-form-checkbox"
        name="lisans"
        :value="item.marketId"
        :data-value="itemParse"
        @change="loadPerspectiveSelect"
      />
    </td>
    <td>
      {{ seperateParanthesisFromTitle(item.name) }}
      <span v-if="paranthesisText != null" class="paranthesis">{{
        paranthesisText
      }}</span>
      <span v-if="item.shortContent">{{ item.shortContent }}</span>
    </td>
    <td>
      <div class="table-dropdown m-flex" v-if="isPerspectiveShow">
        <div class="info">
          <div class="info-option option" v-if="perspectiveData.length > 0">
            <package-setting-select
              ref="perspectiveSelect"
              :defaultValue="defaultPerspectiveID"
              :options="perspectiveData"
              @change="changePerspective"
              :class="paranthesisText != null ? 'mw-70' : ''"
            />
          </div>
        </div>
      </div>
      <div v-else>-</div>
    </td>
    <td>
      <div class="table-dropdown m-flex" v-if="isDistributionShow">
        <div class="info">
          <div class="info-option option" v-if="distributionData.length > 0">
            <package-setting-select
              :key="uuid"
              :defaultValue="defaultDistrubitionID"
              ref="distributionSelect"
              :options="distributionData"
              @change="changeDistribution"
            />
          </div>
        </div>
      </div>
      <div v-else>-</div>
    </td>
    <td v-if="showSelectbox">
      <base-select
        fieldLabel="Başlangıç Zamanı"
        :options="startDate"
        id="startTime"
        @change="changeStartDate"
        :selectedId="startDateSelection"
        placeholder="Seçiniz"
        :data-value="itemParse"
        class="start-date-select"
      />
    </td>
    <td v-else-if="!showSelectbox">-</td>
  </tr>
  <div
    v-else
    class="responsive-table-container"
    :class="isHighlighted && 'highlight'"
  >
    <div class="mobile-wrap">
      <label class="row caption" :for="'input-' + item.marketId">
        <input
          type="checkbox"
          class="base-form-checkbox"
          name="lisans"
          :value="item.marketId"
          :data-value="itemParse"
          @change="loadPerspectiveSelect"
          :id="'input-' + item.marketId"
        />
        {{ item.name }}
        <span v-if="item.shortContent">{{ item.shortContent }}</span>
      </label>
      <div class="row">
        <span class="title">Derinlik</span>
        <div v-if="isPerspectiveShow">
          <div class="info-option option" v-if="perspectiveData.length > 0">
            <package-setting-select
              ref="perspectiveSelect"
              :defaultValue="defaultPerspectiveID"
              :options="perspectiveData"
              @change="changePerspective"
            />
          </div>
        </div>
        <div class="no-data" v-else>-</div>
      </div>
      <div class="row">
        <span class="title">Aracı Kurum Dağılımı</span>
        <div class="table-dropdown m-flex" v-if="isDistributionShow">
          <div class="info">
            <div class="info-option option" v-if="distributionData.length > 0">
              <package-setting-select
                :key="uuid"
                :defaultValue="defaultDistrubitionID"
                ref="distributionSelect"
                :options="distributionData"
                @change="changeDistribution"
              />
            </div>
          </div>
        </div>
        <div class="no-data" v-else>-</div>
      </div>
      <div class="row">
        <span class="title">Başlangıç Zamanı</span>
        <base-select
          v-if="showSelectbox"
          fieldLabel="Başlangıç Zamanı"
          :options="startDate"
          id="startTime"
          @change="changeStartDate"
          :selectedId="startDateSelection"
          placeholder="Seçiniz"
          class="start-date-select"
        />
        <div class="no-data" v-else>-</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PackageSettingSelect from "./PackageSettingSelect.vue";
import { BaseSelect } from "@/components";
import { getItem } from "../../utils/tokenTools";

export default {
  name: "PackageSettingType",
  components: {
    PackageSettingSelect,
    BaseSelect,
  },
  props: {
    dataItem: Object,
    platformInfo: Object,
    selectData: Array,
    item: Object,
    isResponsive: Boolean,
    overallLimit: Number,
  },

  data() {
    return {
      isHighlighted: false,
      perspectiveData: [],
      distributionData: [],
      packageFeatureSelected: {},
      isPerspectiveShow: false,
      isDistributionShow: false,
      uuid: new Date().getTime(),
      selectedMarketID: null,
      defaultPerspectiveID: null,
      defaultDistrubitionID: null,
      cusId: null,
      showSelectbox: false,
      esube: getItem("esube"),
      startDateSelection: -1,
      paranthesisText: null,
      startDate: [
        {
          label: "Seçiniz",
          code: -1,
        },
        {
          label: "Hemen",
          code: 0,
        },
        {
          label: "Ay Başında",
          code: 1,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getPerspectiveInfo",
      "getDistributionInfo",
      "getUserInfo",
      "getOverallLimit",
      "customer",
    ]),
    itemParse() {
      return JSON.stringify(this.item);
    },
    getMemberType() {
      return this.getUserInfo.memberType;
    },
    getServerSideDate() {
      return new Date(this.getUserInfo.date);
    },
    isUserRegisteredBeforeTwentieth() {
      const accountOpeningDate = this.customer.accountOpeningDate;

      const registrationDate = this.parseDate(accountOpeningDate);
      const getLastDayOfMonth = this.parseDateCheckLastDay(registrationDate);

      return (
        registrationDate.getFullYear() ===
          this.getServerSideDate.getFullYear() &&
        registrationDate.getMonth() === this.getServerSideDate.getMonth() &&
        registrationDate.getDate() >= 20 &&
        !getLastDayOfMonth
      );
    },
  },
  methods: {
    ...mapActions(["getPerspective", "getDistribution"]),
    seperateParanthesisFromTitle(title) {
      const getParanthesis = String(title).split("(");

      if (getParanthesis.length > 1) {
        this.paranthesisText = `${"" + getParanthesis[1].replace(")", "")}`;
      }

      return getParanthesis[0];
    },
    loadPerspectiveSelect(e) {
      const dataValue = JSON.parse(e.target.getAttribute("data-value"));
      this.isHighlighted = false;
      if (this.isPerspectiveShow) this.isPerspectiveShow = false;
      if (this.isDistributionShow) this.isDistributionShow = false;
      if (e.target.checked) {
        if (this.esube == "yes" && this.customer.overall != undefined) {
          this.setProductRule(this.customer);
        }
        this.isHighlighted = true;
        this.showSelectbox = true;
        this.getPerspective([
          this.dataItem.applicationId,
          this.dataItem.platform.id,
          e.target.value,
          this.cusId,
        ]).then((data) => {
          if (this.getPerspectiveInfo.length > 0) {
            this.perspectiveData = data;
            this.selectedMarketID = e.target.value;
            this.defaultPerspectiveID = null;
            this.defaultDistrubitionID = null;
            this.isPerspectiveShow = true;
            this.loadDistributionSelect();
            this.fillData(dataValue, this.perspectiveData[0]);
            this.checkSelectedData();
          } else {
            this.fillData(dataValue, null);
            this.checkSelectedData();
          }
        });
        if (dataValue.name === "Hisse + VİOP") {
          this.$emit("showSpesificWarning", true);
        }
      } else {
        this.showSelectbox = false;
        if (dataValue.name === "Hisse + VİOP") {
          this.$emit("showSpesificWarning", false);
        }
        this.$emit(
          "update",
          this.selectData.filter(
            (item) => item?.marketFeature?.id !== dataValue.id
          )
        );
      }
    },
    loadDistributionSelect() {
      this.getDistribution([
        this.dataItem.applicationId,
        this.dataItem.platform.id,
        this.selectedMarketID,
        this.cusId,
      ]).then((data) => {
        if (this.getDistributionInfo.length > 0) {
          this.distributionData = data;
          this.isDistributionShow = true;
          this.packageFeatureSelected.vendorFeature = this.distributionData[0];
        }
      });
    },
    changeStartDate(value) {
      this.startDateSelection = value.code;
      this.packageFeatureSelected.dateSelection = value.code;
      this.checkSelectedData();
    },
    changePerspective(value) {
      this.uuid = new Date().getTime();
      this.packageFeatureSelected.perspectiveFeature = value;
      this.checkSelectedData();
    },
    changeDistribution(value) {
      this.packageFeatureSelected.vendorFeature = value;
      this.defaultDistrubitionID = value.id;
      this.checkSelectedData();
    },
    fillData(marketFeature, perspectiveFeature, vendorFeature = {}) {
      this.packageFeatureSelected.packageId = this.dataItem.id;
      this.packageFeatureSelected.marketFeature = marketFeature;
      this.packageFeatureSelected.platformFeature = this.platformInfo;
      this.packageFeatureSelected.perspectiveFeature = perspectiveFeature;
      this.packageFeatureSelected.vendorFeature = vendorFeature;
      this.packageFeatureSelected.dateSelection = this.startDateSelection;
    },
    parseDate(dateString) {
      const [day, month, year, time] = dateString.split(/\/|\s/);
      const [hours, minutes, seconds] = time.split(":");
      return new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);
    },
    parseDateCheckLastDay(dateString) {
      const year = dateString.getFullYear(),
        month = dateString.getMonth(),
        day = this.getServerSideDate.getDate(),
        getLastDate = new Date(year, month + 1, -1).getDate();
      return day === getLastDate;
    },
    checkSelectedData() {
      const findData = this.selectData.find(
        (item) =>
          item?.marketFeature?.id ===
          this.packageFeatureSelected.marketFeature.id
      );
      if (findData) {
        const newData = { ...findData, ...this.packageFeatureSelected };
        const lastData = this.selectData.map((item) => {
          if (item.marketFeature.id === newData.marketFeature.id) {
            return newData;
          }
          return item;
        });
        this.$emit("update", lastData);
      } else {
        this.selectData.push(this.packageFeatureSelected);
        this.$emit("update", this.selectData);
      }
    },
    setStartDates(listType, startDateSelections) {
      if (listType == -1) {
        this.startDate = [
          {
            label: "Seçiniz",
            code: -1,
          },
          {
            label: "Hemen",
            code: 0,
          },
          {
            label: "Ay Başında",
            code: 1,
          },
        ];
      } else if (listType == 0) {
        this.startDate = [
          {
            label: "Hemen",
            code: 0,
          },
        ];
      } else if (listType == 1) {
        this.startDate = [
          {
            label: "Ay Başında",
            code: 1,
          },
        ];
      }
      this.startDateSelection = startDateSelections;
    },
    setProductRule(val) {
      if (val && !val.error) {
        const overall = parseInt(val?.overall);
        if (
          (this.item.applicationId == 3 || this.item.applicationId == 2) &&
          this.getServerSideDate.getDate() >= 20 &&
          this.item.marketId != 3
        ) {
          this.setStartDates(-1, 1);
        } else if (
          (this.item.applicationId == 3 || this.item.applicationId == 2) &&
          this.item.marketId == 3
        ) {
          if (
            this.getServerSideDate.getDate() >= 20 &&
            this.isUserRegisteredBeforeTwentieth &&
            overall > this.overallLimit
          ) {
            this.setStartDates(-1, 0);
          } else if (
            this.getServerSideDate.getDate() >= 20 &&
            (!this.isUserRegisteredBeforeTwentieth ||
              this.isUserRegisteredBeforeTwentieth) &&
            (overall > this.overallLimit || overall < this.overallLimit)
          ) {
            this.setStartDates(-1, 1);
          } else if (
            this.getServerSideDate.getDate() < 20 &&
            !this.isUserRegisteredBeforeTwentieth &&
            overall > this.overallLimit
          ) {
            this.setStartDates(-1, -1);
          }
        } else if (
          (this.item.applicationId == 3 || this.item.applicationId == 2) &&
          this.item.marketId == 1 &&
          this.item.marketId == 2
        ) {
          if (
            this.getServerSideDate.getDate() >= 20 &&
            this.isUserRegisteredBeforeTwentieth &&
            overall > this.overallLimit
          ) {
            this.setStartDates(-1, 1);
          } else if (
            this.getServerSideDate.getDate() < 20 &&
            !this.isUserRegisteredBeforeTwentieth &&
            overall > this.overallLimit
          ) {
            this.setStartDates(-1, -1);
          }
        } else {
          this.setStartDates(-1, -1);
        }
      }
    },
  },
  mounted() {
    if (this.$route.params.customerId !== undefined) {
      this.cusId = this.$route.params.customerId;
    }
  },
};
</script>

<style lang="scss">
.osm-vd {
  .popup-right {
    @media (max-width: 768px) {
      .algoResearchStyles {
        label {
          display: block !important;
          padding: 0px !important;
          margin-bottom: 10px !important;
          top: auto !important;
          position: relative !important;
          margin-left: 0px !important;
        }
        .vs__dropdown-toggle {
          padding: 5px !important;
          font-size: 14px !important;
          border: 1px solid var(--grayscale-30) !important;
        }
      }
      .form-group .veri-dagitim-selectbox.v-select {
        .vs__dropdown-toggle {
          padding: 0px;
          background: transparent;
          border: none;
        }
        .vs__clear,
        .vs__search {
          display: none;
        }
      }
    }

    .option {
      .veri-dagitim-selectbox.v-select {
        .vs__dropdown-toggle {
          justify-content: space-between;
          min-width: auto;
          width: 270px;
          @media (max-width: 768px) {
            width: 100% !important;
          }
        }
        .vs__selected-options {
          padding: 0;
        }
        .vs__actions {
          margin-right: 0px;
        }
      }
    }
    .start-date-select .form-control-label {
      display: none;
    }
    .mobile-wrap {
      width: 100%;
      font-size: 12px;
      border: 1px solid var(--color-primary-tint-second);
      border-radius: 5px;

      .row {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0px 12px;
        background: var(--grayscale-0);
        > div {
          width: 100%;
        }
        .title {
          box-sizing: border-box;
          width: 100%;
          font-weight: 600;
        }
        &.inline {
          display: flex;
          flex-direction: row;
          justify-content: flex-start !important;
          align-items: center !important;

          > span {
            flex: none;
            max-width: max-content;
            @media (max-width: 768px) {
              &:after {
                content: ":";
                display: inline-block;
                margin-right: 4px;
              }
            }
          }
          > div {
            text-align: left;
            flex: 0 1 50%;
          }
        }
        &:not(.caption) {
          min-height: 63px;
          justify-content: center;
          border-bottom: 1px solid var(--color-primary-tint-second);
          align-items: flex-start;
          &:first-child {
            padding-top: 4px;
          }
        }
        &.caption {
          min-height: 40px;
          background: var(--grayscale-160);
          gap: 0px 6px;
          flex-direction: row;
          input {
            margin: 0px;
          }
        }
        &:nth-child(3n) {
          background: var(--color-primary-zebra);
        }
      }
    }
    .accordion {
      .mobile-wrap {
        .row {
          &:not(.caption) {
            min-height: 40px;
            &:last-child {
              min-height: 48px;
              justify-content: space-evenly;
            }
          }
        }
      }
    }
  }
}
</style>
